/*
 * @Author: bianbinbin
 * @LastEditors: bianbinbin
 * @LastEditTime: 2026-05-28 17:23:50
 * @PageTitle: 页面...
 */

const informationReporting = r =>
  require.ensure([], () => r(require('@/views/informationReporting/informationReporting.vue'), 'informationReporting'))
const reportingDetail = r =>
  require.ensure([], () => r(require('@/views/informationReporting/reportingDetail.vue'), 'reportingDetail'))
const reportingMessage = r =>
  require.ensure([], () => r(require('@/views/informationReporting/reportingMessage.vue'), 'reportingMessage'))
const reportingSuccess = r =>
  require.ensure([], () => r(require('@/views/informationReporting/reportingSuccess.vue'), 'reportingSuccess'))
const router = [
  {
    path: '/informationReporting',
    name: 'informationReporting',
    meta: {
      title: 'AOC信息报送'
    },
    component: informationReporting
  },
  {
    path: '/reportingDetail',
    name: 'reportingDetail',
    meta: {
      title: '信息报送详情'
    },
    component: reportingDetail
  },
  {
    path: '/reportingMessage',
    name: 'reportingMessage',
    meta: {
      title: '发送消息'
    },
    component: reportingMessage
  },
  {
    path: '/reportingSuccess',
    name: 'reportingSuccess',
    meta: {
      title: '发送成功'
    },
    component: reportingSuccess
  }
]

export default router
